import { useEffect } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";

import { EmailRegex } from "../../core/login.core";
import { useTranslation } from "../../core/translation.core";

interface FormData {
  countryCode: string;
  mobileNumber: string;
  userName: string;
  email: string;
}

export default function EmailOrTelInput({ methods }: { methods: UseFormReturn<FormData> }) {
  const watchUserName = useWatch({ name: "userName", control: methods.control });
  const { t, msg } = useTranslation();

  const digitRegex = /^\d+$/;
  const isDigit = digitRegex.test(watchUserName);

  useEffect(() => {
    if (isDigit) {
      methods.setValue("mobileNumber", watchUserName);
      methods.setValue("email", "");
    } else {
      methods.setValue("countryCode", "852");
      methods.setValue("mobileNumber", "");
      methods.setValue("email", watchUserName);
    }
  }, [isDigit, watchUserName, methods]);

  const inputClassName =
    "h-9 bg-transparent text-[#474747] border-b-[1px] border-[#474747] outline-none placeholder:text-[#474747] mb-2 px-2";

  if (isDigit) {
    return (
      <div className="flex ">
        <input
          className={`${inputClassName} w-16`}
          defaultValue="852"
          {...methods.register("countryCode", { required: "please enter validation code" })}
        />
        <div className="w-2"></div>
        <input
          className={`${inputClassName} w-full`}
          type="text"
          placeholder={`${t(msg.login.mobileNumber)}/${t(msg.login.email)}  *`}
          {...methods.register("userName", {
            required: isDigit ? t(msg.login.mobileNumberR) : t(msg.login.emailInvalid),
            pattern: {
              value: isDigit ? digitRegex : EmailRegex,
              message: isDigit ? t(msg.login.mobileNumberInvalid) : t(msg.login.emailInvalid),
            },
          })}
        />
      </div>
    );
  }

  return (
    <div className="flex">
      <label className={`h-9 flex items-center text-[#474747] border-[#474747] w-20`}>{t(msg.contact.email)}</label>

      <input
        className={`${inputClassName} w-full`}
        type="text"
        placeholder={`${t(msg.login.mobileNumber)}/${t(msg.login.email)}  *`}
        {...methods.register("userName", {
          required: isDigit ? t(msg.login.mobileNumberR) : t(msg.login.emailInvalid),
          pattern: {
            value: isDigit ? digitRegex : EmailRegex,
            message: isDigit ? t(msg.login.mobileNumberInvalid) : t(msg.login.emailInvalid),
          },
        })}
      />
    </div>
  );
}
